import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const styles = theme => ({
  root: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.light,
    // wordBreak: 'break-word',
    // whiteSpace: 'nowrap',
    ...theme.typography.p,
  },
});

const StyledTableCell = ({ classes, children }) => (
  <TableCell classes={classes}>{children}</TableCell>
);

StyledTableCell.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
};

export default withStyles(styles)(StyledTableCell);
